import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '@wix/yoshi-flow-editor';
import useLayoutColorClasses from '../../hooks/use-layout-color-classes';
import { PinIcon } from '../icons/pin-icon';
import styles from './pinned-post-icon.scss';

type Props = {
  className?: string;
  iconClassName?: string;
};

export const PinnedPostIcon = ({ className, iconClassName }: Props) => {
  const { t } = useTranslation();
  const layoutColorClasses = useLayoutColorClasses();

  return (
    <div
      className={classNames(styles.root, className)}
      role="img"
      aria-label={t('post-list-item.aria-label.pinned-post')}
    >
      <PinIcon
        aria-hidden="true"
        className={classNames(styles.icon, layoutColorClasses.iconColorClassName, iconClassName)}
      />
    </div>
  );
};
